import { Instagram, Facebook, ExternalLink } from "lucide-react";
import { Reveal } from "./Reveal";
import { SOCIALS } from "../data/site";

const TikTokIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" />
  </svg>
);

export const SOCIAL_ICONS = {
  instagram: Instagram,
  facebook: Facebook,
  tiktok: TikTokIcon,
};

export const Social = () => (
  <section
    id="follow"
    data-testid="follow-section"
    className="relative scroll-mt-20 border-t border-zinc-800/60 py-20 lg:py-28"
  >
    <div
      aria-hidden="true"
      className="absolute left-1/2 top-0 h-64 w-[640px] -translate-x-1/2 rounded-full bg-amber-500/[0.05] blur-[120px]"
    />
    <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <Reveal>
        <p className="eyebrow" data-testid="follow-eyebrow">
          Follow Us
        </p>
        <h2
          data-testid="follow-heading"
          className="mt-3 font-display text-2xl font-bold tracking-tight text-white sm:text-3xl lg:text-4xl"
        >
          Follow Sandstorm
        </h2>
        <p className="mt-4 max-w-2xl leading-relaxed text-zinc-400">
          New inventory, interesting cards and collectibles, behind-the-scenes looks
          and business updates — follow Sandstorm Trading wherever you scroll.
        </p>
      </Reveal>
      <div className="mt-12 grid gap-5 sm:grid-cols-3">
        {SOCIALS.map((s, i) => {
          const Icon = SOCIAL_ICONS[s.id];
          return (
            <Reveal key={s.id} delay={i * 0.06}>
              <a
                href={s.url}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`social-card-${s.id}`}
                className="group flex h-full flex-col rounded-2xl border border-zinc-800 bg-[#12141A] p-7 transition-[border-color,box-shadow,transform] duration-300 hover:-translate-y-1 hover:border-amber-500/40 hover:shadow-[0_0_35px_rgba(212,175,55,0.12)]"
              >
                <div className="inline-flex h-12 w-12 items-center justify-center rounded-full border border-amber-500/30 bg-amber-500/10 transition-colors group-hover:bg-amber-500/20">
                  <Icon className="h-6 w-6 text-amber-300" />
                </div>
                <h3 className="mt-5 font-display text-xl font-semibold text-white">{s.name}</h3>
                <p className="mt-1 text-sm font-medium text-amber-300/90" data-testid={`social-handle-${s.id}`}>
                  {s.handle}
                </p>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-zinc-500">{s.blurb}</p>
                <span
                  data-testid={`social-cta-${s.id}`}
                  className="mt-6 inline-flex items-center gap-2 text-sm font-bold uppercase tracking-wide text-amber-300 transition-colors group-hover:text-amber-200"
                >
                  Follow
                  <ExternalLink className="h-4 w-4 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" aria-hidden="true" />
                </span>
              </a>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
